const { ccclass, property } = cc._decorator;
import ViewBase from "../../../../framework/core/mvvm/view_base";
import TimeManager from "../../../../manager/time_manager";

@ccclass
export default class PlayerInfoSettingView extends ViewBase {
    @property(cc.Node)
    childrenNode:cc.Node = null

    @property(cc.Node)
    btnNode:cc.Node[] = []

    @property(cc.Node)
    bgNode:cc.Node = null;

    btnNameByQgNode = []

    onLoad(){
        for (let index = 0; index < this.btnNode.length; index++) {
            const btnNode = this.btnNode[index];
            this.btnNameByQgNode[btnNode.name] = cc.find("checkmark", btnNode)
        }
    }

    //更新按钮选择显示
    updateBtnChoose(btnName){
        for (const key in this.btnNameByQgNode) {
            if (this.btnNameByQgNode.hasOwnProperty(key)) {
                const btnQgNode = this.btnNameByQgNode[key];
                btnQgNode.active = key == btnName
            }
        }
    }
}